export default function Footer() {
  return (
    <footer className="border-t border-chalk/10 bg-cream py-10">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-5 sm:flex-row">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="" className="h-9 w-9 rounded-full" />
          <p className="text-sm font-semibold text-chalk/70">
            Giant Artichoke Cafe & Grill · Castroville, CA
          </p>
        </div>
        <div className="flex items-center gap-5 text-sm font-semibold">
          <a
            data-testid="footer-phone-link"
            href="tel:8316334259"
            className="text-artichoke transition-colors hover:text-deep"
          >
            (831) 633-4259
          </a>
          <a
            data-testid="footer-instagram-link"
            href="https://instagram.com/giantartichokecafe"
            target="_blank"
            rel="noreferrer"
            className="text-grape transition-colors hover:text-artichoke"
          >
            @giantartichokecafe
          </a>
        </div>
      </div>
    </footer>
  );
}
